import {
  Layout,
} from "antd";
import "antd/dist/reset.css";

import AppRouter from "./Routes";

import { TimerControl } from "../components/custom/TimerControl";
import { FooterView } from "../components/home/FooterView";
import { MenuView } from "../components/home/MenuView";
import { HeaderView } from "../components/home/HeaderView";

const { Header, Content, Footer } = Layout;

export const AuthorizedLayout = () => {

  return (
    <div>
      <Layout
        className="site-layout public"
        style={{
          marginLeft: 200,
        }}
      >
        <Header>
          <HeaderView />
        </Header>
        <MenuView />

        <Content style={{ margin: "0 16px" }}>
          <>
            <TimerControl />
            <AppRouter />
          </>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          <FooterView />
        </Footer>

      </Layout>
    </div>
  );
};

export default AuthorizedLayout;
